import { defineType, defineField } from "sanity";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  type: "object",
  name: "inclusionItem",
  title: "Inclusion Item",
  fields: [
    defineField({
      name: "inclusionCategory",
      title: "Category",
      type: "reference",
      to: [{ type: "suiteClassInclusionCategory" }],
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "item",
      title: "Item",
      type: "multilingualArrayString",
      validation: (Rule) => Rule.required()
    })
  ],
  preview: {
    select: {
      title: "item",
      inclusionCategory: "inclusionCategory.title"
    },
    prepare: ({ title, inclusionCategory }) => ({
      title: multilingualStringPreview(title),
      subtitle: multilingualStringPreview(inclusionCategory)
    })
  }
});
